export default __webpack_public_path__ + "static/media/gallery_16.3da83a80.jpg";